import React, { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [access, setAccess] = useState(localStorage.getItem('access'));
  const [refresh, setRefresh] = useState(localStorage.getItem('refresh'));
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('access'));

  useEffect(() => {
    setIsAuthenticated(!!access);
  }, [access]);

  const login = (accessToken, refreshToken) => {
    localStorage.setItem('access', accessToken);
    localStorage.setItem('refresh', refreshToken);
    setAccess(accessToken);
    setRefresh(refreshToken);
    setIsAuthenticated(true);
  };

  const logout = () => {
    localStorage.removeItem('access');
    localStorage.removeItem('refresh');
    setAccess(null);
    setRefresh(null);
    setIsAuthenticated(false);
  };

  // The shared API client (src/api/client.js) refreshes tokens on 401 and
  // reports the outcome through window events.
  useEffect(() => {
    const onRefreshed = (e) => setAccess(e.detail);
    const onLogout = () => logout();
    window.addEventListener('auth:refreshed', onRefreshed);
    window.addEventListener('auth:logout', onLogout);
    return () => {
      window.removeEventListener('auth:refreshed', onRefreshed);
      window.removeEventListener('auth:logout', onLogout);
    };
  }, []);

  return (
    <AuthContext.Provider value={{ access, refresh, isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
